import React, { Children } from 'react'
import PropTypes from 'prop-types'

import s from './VisuallyHidden.scss'


const VisuallyHidden = ({ children }) => (
  Children.map(children, (child) => (
    React.cloneElement(child, { className: s.visuallyHidden })
  ))
)

VisuallyHidden.propTypes = {
  children: PropTypes.node.isRequired,
}


export default VisuallyHidden
